import React from 'react';
import { Box, Typography } from '@mui/material';

import RawHtml from '../../legacy/components/base/RawHtml';

// ********************************************************************************
// The secondary banner component has multiple layouts to work with.
// This is the service layout, which display the title and description in two
// columns.
type Props = {
  title: string;
  description: string;
};
export const SecondaryBannerServiceLayout = (props: Props) => (
  <Box display="flex" flexWrap="wrap">
    <Box display="flex" alignItems="center" width={{ xs: '100%', md: '50%' }} p={1}>
      <Typography variant="h2" color="#3F2B56" fontFamily="Gotham-Medium" fontSize="32px" align="left">
        {props.title}
      </Typography>
    </Box>
    <Box width={{ xs: '100%', md: '50%' }} p={1}>
      <Box
        mx="auto"
        color="#302F2F"
        fontSize="16px"
        lineHeight="19.2px"
        fontFamily="Gotham-Book"
        textAlign="left"
      >
        <RawHtml content={props.description} />
      </Box>
    </Box>
  </Box>
);
